export const MENU_DATA = [
    {
        id: "home_main",
        name: "Familie",
        category: "family",
        pathname: "/family",
        subMenu: [
            {
                name: "TVS >", category: "tvs", pathname: "/family/tvs/tv/OLED65G29LA",
            },
            {
                name: "Soundbars >", category: "av", pathname: "/family/av/soundbar/DSP11RA",
            },
            {
                name: "Notebooks >", category: "laptop", pathname: "/family/laptop/laptop/17Z90Q-G.AD7CG",
            },
            {name: "Kühlschränke mit Gefrierfach >", category: "fridge", pathname: "/family/fridge/side_by_sides/GSXV90MCDE"},
            {
                name: "Tragbare Lautsprecher >",
                category: "portable_speakers",
                pathname: "/family/portable_speakers/portable_speaker/DXG7QBK"
            },
            {name: "Waschmaschinen & Waschtrockner >", category: "wm", pathname: "/family/wm/wm/F4WV709P2BA"},
            {name: "LG Styler >", category: "styler", pathname: "/family/styler/styler/S3WF"}
        ]
    },
    {
        id: "studio_main",
        name: "Studio",
        category: "studio",
        pathname: "/studio",
        subMenu: [
            {
                name: "TVS >", category: "tvs", pathname: "/studio/tvs/tv/OLED65G29LA",
            },
            {
                name: "Soundbars >", category: "av", pathname: "/studio/av/soundbar/DSP11RA",
            },
            {name: "Kühlschränke mit Gefrierfach >", category: "fridge", pathname: "/studio/fridge/side_by_sides/GSXV90MCDE"},
            {
                name: "Tragbare Lautsprecher >",
                category: "portable_speakers",
                pathname: "/studio/portable_speakers/portable_speaker/DXG7QBK"
            },
            {name: "Beamer >", category: "it", pathname: "/studio/it/beam_projector/HU715QW"},
            // {name: "AIR CONDITIONER >", category: "air", pathname: "/studio/air/air_conditioner/DC12RH"},
            {name: "Waschmaschinen & Waschtrockner >", category: "wm", pathname: "/studio/wm/wm/F4WV709P2BA"},
            {name: "LG Styler >", category: "styler", pathname: "/studio/styler/styler/S3WF"}
        ]
    },
    {
        id: "office_main",
        name: "Home office",
        category: "office",
        pathname: "/office",
        subMenu: [
            {
                name: "TVS >", category: "tvs", "pathname": "/office/tvs/tv/OLED65G29LA",
            },
            {
                name: "Soundbars >", category: "av", "pathname": "/office/av/soundbar/DSP11RA",
            },
            {name: "Monitore >", category: "monitor", "pathname": "/office/monitor/monitor/38WN95C-W"},
            {name: "Notebooks >", category: "laptop", "pathname": "/office/laptop/laptop/17Z90Q-G.AD7CG"},
            {name: "Bluetooth Kopfhörer >", category: "tone", "pathname": "/office/tone/earbuds/TONE-DFP8"},
            {
                name: "Tragbare Lautsprecher >",
                category: "portable_speakers",
                "pathname": "/office/portable_speakers/portable_speaker/DXG7QBK"
            },
            // {name: "WINE CELLER >", category: "wine_celler", "pathname": "/office/wine_celler/wine_celler/LSR200W"},
            // {name: "AIR CONDITIONER >", category: "air", "pathname": "/office/air/air_conditioner/DC12RH"},
        ]
    }
];


export const MAP_DATA = [
    {
        "category": "family",
        "bgUrl": "/img/minimap/minimap_home.png",
        "spots": [
            {
                "x": 0.4,
                "y": 5.5,
                "target": "home_tv",
                "categories": ["tvs", "av"],
                "pathname": '/family/tvs/tv/OLED65G29LA',
                "label": 'TVS / SOUNDBARS',
                "w": '18rem'
            },
            {
                "x": 4.7,
                "y": 3.7,
                "target": "home_tv",
                "categories": ["laptop", "mobile"],
                "pathname": '/family/laptop/laptop/17Z90Q-G.AD7CG',
                "label": 'NOTEBOOKS'
            },
            {
                "x": 16.4,
                "y": 4.16,
                "target": "home_fr",
                "categories": ["portable_speakers"],
                "pathname": '/family/portable_speakers/portable_speaker/DXG7QBK',
                "label": 'Tragbare Lautsprecher',
                "w":'26rem',
            },
            {
                "x": 18.8,
                "y": 3.2,
                "target": "home_fr",
                "categories": ["fridge", "combi"],
                "pathname": '/family/fridge/side_by_sides/GSXV90MCDE',
                "label": 'Kühlschränke mit Gefrierfach',
                "w":'32rem',
            },
            {
                "x": 21.2,
                "y": 6,
                "target": "home_wash",
                "categories": ["wm", "washer_dryers", "styler"],
                "pathname": '/family/wm/wm/F4WV709P2BA',
                "label": 'Waschmaschinen & Waschtrockner / Styler',
                "w":'26rem',
            },
        ]
    },
    {
        "category": "studio",
        "bgUrl": "/img/minimap/minimap_studio.png",
        "spots": [
            {
                "x": 1.1,
                "y": 12.7,
                "target": "studio_projector",
                "categories": ["it", "portable_speakers"],
                "pathname": "/studio/it/beam_projector/HU715QW",
                "label": 'Beamer / Tragbare Lautsprecher',
                "w":'35rem',
            },
            // {
            //     "x": 1.1,
            //     "y": 7.2,
            //     "target": "studio_projector",
            //     "categories": ["air"],
            //     "pathname": "/studio/air/air_conditioner/DC12RH",
            //     "label": 'AIR CONDITIONER'
            // },
            {
                "x": 7.8,
                "y": 0.5,
                "target": "studio_toilet",
                "categories": ["wm", "styler", "washer_dryers"],
                "pathname": "/studio/wm/wm/F4WV709P2BA",
                "label": 'Waschmaschinen & Waschtrockner / Styler',
                "w":'26rem',
            },
            {
                "x": 8.8,
                "y": 7,
                "target": "studio_tv",
                "categories": ["tvs", "av"],
                "pathname": "/studio/tvs/tv/OLED65G29LA",
                "label": 'TVS / SOUNDBARS',
                "w": '18rem'
            },
            {
                "x": 13.4,
                "y": 13.4,
                "target": "studio_fr",
                "categories": ["fridge"],
                "pathname": "/studio/fridge/side_by_sides/GSXV90MCDE",
                "label": 'Kühlschränke mit Gefrierfach',
                "w":'32rem',
            },
        ]
    },
    {
        "category": "office",
        "bgUrl": "/img/minimap/minimap_office.png",
        "spots": [
            {
                "x": 4.8,
                "y": 0.4,
                "target": "office_monitor",
                "categories": ["monitor", "laptop", "portable_speakers", "tone"],
                "pathname": "/office/monitor/monitor/38WN95C-W",
                "label": "Monitore / Notebooks / Bluetooth Kopfhörer / Tragbare Lautsprecher",
                "w": '46.5rem'
            },
            {
                "x": 4.1, "y": 11.8, "target": "office_tv", "categories": ["tvs", "av", "air"],
                "pathname": "/office/tvs/tv/OLED65G29LA",
                "label": "TVS / SOUNDBARS",
                "w": '18rem'
            },
            // {
            //     "x": 13, "y": 11.5, "target": "office_tv", "categories": ["wine_celler"],
            //     "pathname": "/office/wine_celler/wine_celler/LSR200W",
            //     "label": "WINE CELLER"
            // },
        ]
    }
];

export function getMapData(sceneCategory) {
    if (sceneCategory === null) return null;
    let result = null;
    for (let i = 0; i < MAP_DATA.length; i++) {
        if (MAP_DATA[i].category === sceneCategory) {
            result = MAP_DATA[i];
            break;
        }
    }
    return result;
}
